import { getBookingsRelativeUrl, getSectionRelativeUrl, getUrlQueryParams, queryBuilder, isBookingsSectionInstalled, BOOKINGS_SERVICE_PAGE_SECTION_ID } from '@wix/bookings-catalog-calendar-viewer-utils';
import { UrlMappingsKeys } from '@wix/url-mapper-utils';
async function getServicePageRelativeUrl(_ref) {
  let {
    isUseCustomUrlSegmentsEnabled,
    serviceSlug,
    wixCodeApi
  } = _ref;
  if (isUseCustomUrlSegmentsEnabled) {
    const customSegmentRelativeUrl = await (wixCodeApi.location.buildCustomizedUrl == null ? void 0 : wixCodeApi.location.buildCustomizedUrl(UrlMappingsKeys.BOOKINGS_SERVICE, {
      slug: serviceSlug
    }, {
      baseUrl: ''
    }));
    if (customSegmentRelativeUrl) {
      return customSegmentRelativeUrl;
    }
    let servicePageRelativeUrl;
    if (await isBookingsSectionInstalled(wixCodeApi, BOOKINGS_SERVICE_PAGE_SECTION_ID)) {
      servicePageRelativeUrl = await getSectionRelativeUrl(wixCodeApi, BOOKINGS_SERVICE_PAGE_SECTION_ID);
    } else {
      servicePageRelativeUrl = getBookingsRelativeUrl(wixCodeApi);
    }
    return servicePageRelativeUrl + `/${serviceSlug}`;
  } else {
    if (await isBookingsSectionInstalled(wixCodeApi, BOOKINGS_SERVICE_PAGE_SECTION_ID)) {
      return getSectionRelativeUrl(wixCodeApi, BOOKINGS_SERVICE_PAGE_SECTION_ID);
    }
    return getBookingsRelativeUrl(wixCodeApi);
  }
}
export async function navigateToBookingsServicePage(wixCodeApi, _ref2, isUseCustomUrlSegmentsEnabled) {
  let {
    serviceSlug,
    referral,
    location
  } = _ref2;
  const query = queryBuilder({
    ...getUrlQueryParams(wixCodeApi),
    ...{
      referral,
      location
    }
  });
  const servicePageRelativeUrl = await getServicePageRelativeUrl({
    isUseCustomUrlSegmentsEnabled,
    serviceSlug,
    wixCodeApi
  });
  if (isUseCustomUrlSegmentsEnabled) {
    return wixCodeApi.location.to(servicePageRelativeUrl + query);
  }
  const suffix = `${serviceSlug}`;
  wixCodeApi.location.to(`${servicePageRelativeUrl}/${suffix + query}`);
}
//# sourceMappingURL=navigateToBookingsServicePage.js.map